<template>
  <nav id="puzzle-nav">
    <ul class="nav nav-pills">
      <li class="nav-item">
       <router-link :to="{
          name: 'create_puzzle'
        }" :class="isActive('upload')">
          Upload New Puzzle
        </router-link>
      </li>
      <li
        class="nav-item"
        v-if="puzzleId"
      >
       <router-link :to="{
          name: 'edit_puzzle',
          params: { puzzleId: puzzleId }
        }" :class="isActive('edit_puzzle')">
          Edit Puzzle
        </router-link>
      </li>
      <li
        class="nav-item"
        v-if="purchasableItemId"
      >
        <router-link
          :to="{
            name: 'purchasable_item',
            params: {
              purchasableItemId: purchasableItemId
            }
          }"
          :class="isActive('edit_puzzle')"
        >
          Purchasable Item
        </router-link>
      </li>
      <li
        class="nav-item"
        v-else
      >
        <router-link
          :to="{
            name: 'create_purchasable_item'
          }"
          class="nav-link"
        >
          Create Purchasable Item
        </router-link>
      </li>
      <li
        class="nav-item"
        v-if="!puzzleId"
      >
        <puzzles-options />
      </li>
    </ul>
  </nav>
</template>

<script>
import PuzzlesOptions from '@/components/PuzzlesOptions'

export default {
  props: [
    'active', 'purchasableItemId', 'puzzleId'
  ],

  components: {
    'puzzles-options': PuzzlesOptions
  },

  methods: {
    isActive (lbl) {
      let className = 'nav-link'
      if (!this.active) {
        return className
      }

      if (lbl === this.active) {
        return className + ' active'
      }
    }
  }
}
</script>

<style scoped>
main nav {
  margin-top: 0;
  margin-bottom: 1em;
}

.nav {
  border-top: 0
}
</style>



// WEBPACK FOOTER //
// src/components/PuzzleNav.vue